import { useEffect, useState } from "react";
import { track } from "../lib/analytics";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { useFetch } from "../lib/hooks";
import { ArticleCard } from "../components/site/ArticleCard";
import { EmptyState, PageHeader } from "../components/site/Blocks";
import { Seo } from "../components/site/Seo";
import { BrandLoader } from "../components/site/Logo";

const Results = ({ q }) => {
  const { data, loading } = useFetch(`/public/search?q=${encodeURIComponent(q)}`);
  useEffect(() => {
    if (data) track("search_performed", { results: data.total || 0, term_length: q.length });
  }, [data, q]);
  if (loading) return <BrandLoader label="Pretraga…" />;
  if (!data?.items?.length) return <EmptyState title={`Nema rezultata za „${q}"`} text="Pokušajte s drugim pojmom ili pregledajte rubrike." testId="search-empty" />;
  return (
    <>
      <p className="mb-4 text-sm text-muted-foreground" data-testid="search-result-count">{data.total} {data.total % 10 === 1 && data.total % 100 !== 11 ? "rezultat" : "rezultata"} za „{q}"</p>
      <div className="divide-y divide-border" data-testid="search-results">{data.items.map((a) => <ArticleCard key={a.id} a={a} variant="compact" />)}</div>
    </>
  );
};

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [value, setValue] = useState(q);
  const nav = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    if (value.trim().length >= 2) nav(`/pretraga?q=${encodeURIComponent(value.trim())}`);
  };
  return (
    <div className="container-news max-w-3xl" data-testid="search-page">
      <Seo title={q ? `Pretraga: ${q}` : "Pretraga"} noindex />
      <PageHeader kicker="Pretraga" title="Pretražite BalkanPuls" />
      <form role="search" onSubmit={submit} className="relative mt-8">
        <label htmlFor="search-main" className="sr-only">Pojam za pretragu</label>
        <Search className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-muted-foreground" />
        <input id="search-main" autoFocus value={value} onChange={(e) => setValue(e.target.value)} placeholder="npr. Blue Card, Kindergeld, porezna klasa…" className="h-14 w-full rounded-full border border-input bg-card pl-12 pr-32 text-base outline-none focus:ring-2 focus:ring-ring" data-testid="search-input-field" />
        <button type="submit" className="absolute right-2 top-1/2 h-10 -translate-y-1/2 rounded-full bg-navy px-6 text-sm font-semibold text-white transition-colors hover:bg-navy-700 dark:bg-pulse" data-testid="search-submit-button">Traži</button>
      </form>
      <div className="mt-10">{q.length >= 2 ? <Results q={q} /> : <p className="text-sm text-muted-foreground">Unesite najmanje dva znaka.</p>}</div>
    </div>
  );
}
